export class WhiteVariety {

    constructor(readonly name: string) {
    }
}



// WEBPACK FOOTER //
// ./src/api/request/WhiteVariety.ts